import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";

type SectionWrapperProps = BoxProps & {
  ref?: React.ForwardedRef<HTMLDivElement>;
};

const SectionWrapper = ({ children, className, ref, ...restBoxProps }: SectionWrapperProps) => (
  <Box
    direction="column"
    fullWidth
    className={cx(styles.wrapper, className)}
    ref={ref}
    {...restBoxProps}
  >
    {children}
  </Box>
);

SectionWrapper.displayName = "DS.Section.Wrapper";

export default SectionWrapper;
